/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AtsIntegrationCto } from '../../models/ats-integration-cto';
import { SetAtsIntegrationStatusCto } from '../../models/set-ats-integration-status-cto';

export interface SetAtsIntegrationStatus$Plain$Params {
  companyGuid: string;
      body?: SetAtsIntegrationStatusCto
}

export function setAtsIntegrationStatus$Plain(http: HttpClient, rootUrl: string, params: SetAtsIntegrationStatus$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AtsIntegrationCto>> {
  const rb = new RequestBuilder(rootUrl, setAtsIntegrationStatus$Plain.PATH, 'patch');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AtsIntegrationCto>;
    })
  );
}

setAtsIntegrationStatus$Plain.PATH = '/integrations/companies/{companyGuid}/ats-integration/status';
